if (!customElements.get('component-bra-calculator')) {
  customElements.define('component-bra-calculator', class BraCalculator extends HTMLElement {
    constructor() {
      super();
      this.dom = {
        bandSizeInput: this.querySelector('#bra-calc-form-band-size'),
        bustSizeInput: this.querySelector('#bra-calc-form-bust-size'),
        submitBtn: this.querySelector('.bra-calc-form-submit'),
        resultsPanel: this.querySelector('.bra-calc-result'),
        resultsSize: this.querySelector('.js-bra-calc-result-size'),
        shopLink: this.querySelector('.bra-calc-result a'),
        errorMsg: this.querySelector('.js-bra-calc-form-error'),
      };

      // bandSizes, braSizes and smallestCupByBand are mirrored by the server-rendered size charts
      // (snippets/bra-size-data.liquid): keep both in sync
      this.bandSizes = {
        30: [24.9, 28.5],
        32: [28.5, 30.5],
        34: [30.5, 32.5],
        36: [32.5, 34.5],
        38: [34.5, 36.5],
        40: [36.5, 38.5],
        42: [38.5, 40.5],
        44: [40.5, 42.5],
        46: [42.5, 44.5],
      };

      this.braSizes = {
        "-0.1|2.5": ["34AA"],
        "2.5|3": ["34AA", "30B", "32A"],
        "3|3.5": ["30C", "32B", "34A"],
        "3.5|4": ["30C½", "32B½", "34A½"],
        "4|4.5": ["30D", "32C", "34B", "36A"],
        "4.5|5": ["30D", "32C½", "34B½", "36A½"],
        "5|5.5": ["30E", "32D", "34C", "36B", "38A"],
        "5.5|6": ["30E½", "32D½", "34C½", "36B½", "38A½"],
        "6|6.5": ["30F", "32E", "34D", "36C", "38B"],
        "6.5|7": ["30F", "32E½", "34D½", "36C½", "38B½"],
        "7|8": ["30G", "32F", "34E", "36D", "38C", "40B"],
        "8|9": ["32G", "34F", "36E", "38D", "40C", "42B"],
        "9|10": ["34G", "36F", "38E", "40D", "42C", "44B"],
        "10|11": ["34H", "36G", "38F", "40E", "42D", "44C"],
        "11|12": ["36H", "38G", "40F", "42E", "44D"],
        "12|13": ["38H", "40G", "42F", "44E"]
      };

      this.smallestCupByBand = {
        2.5: ['30B', '32A', '34AA'],
        4: ['36A'],
        5: ['38A'],
        7: ['40B'],
        8: ['42B'],
        9: ['44B'],
      }
    }

    connectedCallback() {
      this.dom.submitBtn.addEventListener('click', () => {
        const bust = Number(this.dom.bustSizeInput.value);
        const underbust = Number(this.dom.bandSizeInput.value);

        if (bust < underbust) {
          this.showErrorMsg('The bust size should be greater than the underbust size');
          return;
        }

        const bandSize = this.calculateBandSize(underbust);
        const braSize = this.getBraSize(bust, underbust, bandSize);
        if (!braSize) {
          this.showErrorMsg('We’re sorry, we don’t currently carry your size.');
          return;
        }

        this.dom.resultsSize.innerText = braSize;
        this.dom.submitBtn.innerText = 'Your size below';
        this.dom.resultsPanel.style.display = 'flex';
        this.dom.errorMsg.innerText = '';
        this.dom.shopLink.href = `/collections/bras?filter.v.option.size=${braSize.replace(/½/, '')}`
        window.dispatchEvent(new CustomEvent('bra-calculator-finished', { detail: { size: braSize }}));
      });
    }

    getBraSize(bust, underbust, bandSize) {
      const diff = Number.parseFloat(bust - underbust);
      // If the diff matches the lower value for the band return the smaller cup
      if (this.smallestCupByBand[diff]) {
        const smallest = this.smallestCupByBand[diff].find((size) => size.startsWith(bandSize));
        if (smallest) {
          return smallest;
        }
      }
      for (const [key, value] of Object.entries(this.braSizes)) {
        const [min, max] = key.split('|');
        if (diff > Number.parseFloat(min) && diff <= Number.parseFloat(max)) {
          return value.find((size) => size.startsWith(bandSize));
        }
      }
    }

    calculateBandSize(band) {
      for (const [key, value] of Object.entries(this.bandSizes)) {
        if (band > value[0] && band <= value[1]) {
          return key;
        }
      }
    }

    showErrorMsg(msg) {
      this.dom.errorMsg.innerText = msg;
      this.dom.resultsPanel.style.display = 'none';
      this.dom.submitBtn.innerText = this.dom.submitBtn.dataset.btnText;
    }
  });
}
